import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Icon from '../components/Icon';
import './Login.css';

export default function Login() {
  const navigate = useNavigate();
  const [step, setStep]           = useState('credentials'); // 'credentials' | '2fa'
  const [username, setUsername]   = useState('');
  const [password, setPassword]   = useState('');
  const [code, setCode]           = useState('');
  const [tempToken, setTempToken] = useState('');
  const [erreur, setErreur]       = useState('');
  const [chargement, setChargement] = useState(false);
  const codeInputRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('escamel_token');
    if (token) navigate('/', { replace: true });
  }, [navigate]);

  useEffect(() => {
    if (step === '2fa' && codeInputRef.current) {
      codeInputRef.current.focus();
    }
  }, [step]);

  async function handleCredentials(e) {
    e.preventDefault();
    setErreur('');
    setChargement(true);
    try {
      const res = await axios.post('/api/auth/login', { username, password });

      if (res.data.requires_2fa) {
        setTempToken(res.data.temp_token);
        setStep('2fa');
      } else {
        localStorage.setItem('escamel_token', res.data.token);
        localStorage.setItem('escamel_user', JSON.stringify({ username: res.data.username, nom: res.data.nom }));
        navigate('/', { replace: true });
      }
    } catch (err) {
      setErreur(err.response?.data?.error || 'Erreur de connexion');
    } finally {
      setChargement(false);
    }
  }

  async function handleVerify2fa(e) {
    e.preventDefault();
    setErreur('');
    setChargement(true);
    try {
      const res = await axios.post('/api/auth/verify-2fa', { temp_token: tempToken, code });
      localStorage.setItem('escamel_token', res.data.token);
      localStorage.setItem('escamel_user', JSON.stringify({ username: res.data.username, nom: res.data.nom }));
      navigate('/', { replace: true });
    } catch (err) {
      setErreur(err.response?.data?.error || 'Code invalide');
      setCode('');
    } finally {
      setChargement(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card rise-in">

        {/* Logo & marque */}
        <div className="login-brand">
          <div className="login-logo-wrap">
            <img src="/logo.png" alt="Escamel" className="login-logo-img" />
          </div>
          <div className="login-brand-name">ESCAMEL</div>
          <div className="login-brand-sub">Artisans du Fumoir</div>
        </div>

        {/* Filet accent sous le titre */}
        <div className="login-divider" />

        {/* Étape 1 : identifiants */}
        {step === 'credentials' && (
          <form className="login-form" onSubmit={handleCredentials} noValidate>
            <div className="field">
              <label htmlFor="username">Utilisateur</label>
              <input
                id="username"
                type="text"
                value={username}
                onChange={e => setUsername(e.target.value)}
                autoComplete="username"
                autoFocus
                required
              />
            </div>

            <div className="field">
              <label htmlFor="password">Mot de passe</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
            </div>

            {erreur && (
              <div className="error-inline">
                <Icon name="alerte" size={15} />
                {erreur}
              </div>
            )}

            <button
              type="submit"
              className="btn btn-primary btn--block btn--lg"
              disabled={chargement}
            >
              {chargement
                ? <><span className="login-spinner" /> Connexion…</>
                : 'Se connecter'
              }
            </button>
          </form>
        )}

        {/* Étape 2 : code 2FA */}
        {step === '2fa' && (
          <form className="login-form" onSubmit={handleVerify2fa} noValidate>
            <div className="login-2fa-info">
              <span className="login-2fa-icon">
                <Icon name="verrou" size={28} color="var(--accent)" />
              </span>
              <p>Entrez le code à 6 chiffres<br />de votre application d'authentification</p>
            </div>

            <div className="field">
              <label htmlFor="code">Code de vérification</label>
              <input
                id="code"
                ref={codeInputRef}
                type="text"
                inputMode="numeric"
                pattern="[0-9 ]*"
                maxLength={7}
                placeholder="000 000"
                value={code}
                onChange={e => setCode(e.target.value.replace(/[^0-9 ]/g, ''))}
                autoComplete="one-time-code"
                required
                className="login-code-input"
              />
            </div>

            {erreur && (
              <div className="error-inline">
                <Icon name="alerte" size={15} />
                {erreur}
              </div>
            )}

            <button
              type="submit"
              className="btn btn-primary btn--block btn--lg"
              disabled={chargement}
            >
              {chargement
                ? <><span className="login-spinner" /> Vérification…</>
                : 'Vérifier'
              }
            </button>

            <button
              type="button"
              className="btn btn-ghost btn--block"
              onClick={() => { setStep('credentials'); setErreur(''); setCode(''); }}
            >
              <Icon name="retour" size={14} />
              Retour
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
